module.exports = __webpack_public_path__ + "static/media/winter.92e93dfe.jpeg";